import { createContext } from 'react';
import { AppStore } from './AppStore';
import { KeywordStore } from './KeywordStore';
import { PageStore } from './PageStore';
import { PhasesStore } from './PhasesStore';
import { SearchStore } from './SearchStore';
import { SiteStore } from './SiteStore';
import { StepsStore } from './StepsStore';

declare global {
  interface Window {
    sq: any;
  }
}

export type error = { name: string; message: string } | null;
export class RootStore {
  phasesStore = new PhasesStore(this);
  siteStore = new SiteStore(this);
  pageStore = new PageStore(this);
  appStore = new AppStore(this);
  searchStore = new SearchStore(this);
  keywordStore = new KeywordStore(this);
  stepsStore = new StepsStore(this);
}

export async function fetchData(url: string): Promise<any> {
  const response = await fetch(url);
  if (response.ok) {
    try {
      const responseText = await response.text();
      return JSON.parse(responseText);
    } catch (err) {
      const invalidJson = new Error(`<div style="
      padding: 20px;"> <h1>Unable to parse JSON</h1><p>Try leater or check url ${url}</p><p>${err}</p>`);
      invalidJson.name = '';
      throw invalidJson;
    }
  } else {
    const dataNotFound = new Error(
      `Page ${response.statusText}. Try leater or check url ${response.url}`
    );
    dataNotFound.name = `${response.statusText} - ${response.status}`;
    throw dataNotFound;
  }
}

export const RootStoresContext = createContext(new RootStore());
